<template>
  <Teleport to="body">
    <template v-if="visivel">
      <div class="modal fade show d-block" tabindex="-1" @click.self="fechar">
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable crm-modal-wide">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ campo ? 'Editar Campo Personalizado' : 'Novo Campo Personalizado' }}</h5>
              <button type="button" class="btn-close" @click="fechar"></button>
            </div>

            <form @submit.prevent="salvar">
              <div class="modal-body">
                <BRow class="g-3">
                  <BCol md="6">
                    <label class="form-label">Nome de exibição <span class="text-danger">*</span></label>
                    <input v-model="form.nomeExibicao" type="text" class="form-control" :class="{ 'is-invalid': erros.nomeExibicao }" />
                    <div v-if="erros.nomeExibicao" class="invalid-feedback">{{ erros.nomeExibicao }}</div>
                  </BCol>
                  <BCol md="6">
                    <label class="form-label">Chave técnica <span class="text-danger">*</span></label>
                    <input v-model="form.chaveTecnica" type="text" class="form-control" :class="{ 'is-invalid': erros.chaveTecnica }" />
                    <div v-if="erros.chaveTecnica" class="invalid-feedback">{{ erros.chaveTecnica }}</div>
                  </BCol>
                  <BCol md="4">
                    <label class="form-label">Tipo do campo <span class="text-danger">*</span></label>
                    <Multiselect
                      v-model="form.tipoCampo"
                      :options="tiposCampo"
                      label="label"
                      value-prop="value"
                      :searchable="true"
                      :can-clear="false"
                      :can-deselect="false"
                    />
                  </BCol>
                  <BCol md="2">
                    <label class="form-label">Ordem</label>
                    <input v-model.number="form.ordemExibicao" type="number" min="0" class="form-control" />
                  </BCol>
                  <BCol md="3">
                    <div class="form-check form-switch mt-4 pt-2">
                      <input v-model="form.obrigatorio" class="form-check-input" type="checkbox" />
                      <label class="form-check-label">Campo obrigatório</label>
                    </div>
                  </BCol>
                  <BCol md="3">
                    <div class="form-check form-switch mt-4 pt-2">
                      <input v-model="form.ativo" class="form-check-input" type="checkbox" />
                      <label class="form-check-label">Campo ativo</label>
                    </div>
                  </BCol>
                  <BCol md="12">
                    <label class="form-label">Descrição de ajuda</label>
                    <textarea v-model="form.descricaoAjuda" rows="2" class="form-control" placeholder="Texto de apoio exibido abaixo do campo"></textarea>
                  </BCol>
                </BRow>

                <div v-if="usaOpcoes" class="mt-4">
                  <CampoPersonalizadoOpcoesEditor v-model="form.opcoes" />
                  <div v-if="erros.opcoes" class="text-danger small mt-2">{{ erros.opcoes }}</div>
                </div>
              </div>

              <div class="modal-footer">
                <BButton variant="ghost-dark" @click="fechar">Cancelar</BButton>
                <BButton type="submit" variant="success" :disabled="salvando">
                  <BSpinner v-if="salvando" small class="me-1" />
                  {{ salvando ? 'Salvando...' : 'Salvar' }}
                </BButton>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show" @click="fechar"></div>
    </template>
  </Teleport>
</template>

<script>
import CampoPersonalizadoOpcoesEditor from './CampoPersonalizadoOpcoesEditor.vue';

const LIST_TYPES = ['dropdown', 'multiselect_single', 'multiselect_tags', 'radio'];

const emptyForm = () => ({
  nomeExibicao: '',
  chaveTecnica: '',
  tipoCampo: 'text',
  ordemExibicao: 0,
  obrigatorio: false,
  ativo: true,
  descricaoAjuda: '',
  opcoes: [],
});

export default {
  name: 'CampoPersonalizadoForm',
  components: { CampoPersonalizadoOpcoesEditor },
  props: {
    visivel: { type: Boolean, default: false },
    campo: { type: Object, default: null },
  },
  emits: ['fechar', 'salvar'],
  data() {
    return {
      form: emptyForm(),
      erros: {},
      salvando: false,
      tiposCampo: [
        { value: 'text', label: 'Texto' },
        { value: 'number', label: 'Número' },
        { value: 'dropdown', label: 'Lista suspensa' },
        { value: 'multiselect_single', label: 'Seleção única' },
        { value: 'multiselect_tags', label: 'Múltiplas seleções' },
        { value: 'radio', label: 'Botões de opção' },
        { value: 'checkbox', label: 'Checkbox' },
        { value: 'date', label: 'Data' },
        { value: 'time', label: 'Hora' },
        { value: 'color', label: 'Cor' },
      ],
    };
  },
  computed: {
    usaOpcoes() {
      return LIST_TYPES.includes(this.form.tipoCampo);
    },
  },
  watch: {
    campo: {
      immediate: true,
      handler(value) {
        this.form = value
          ? {
              nomeExibicao: value.nome_exibicao || '',
              chaveTecnica: value.chave_tecnica || '',
              tipoCampo: value.tipo_campo || 'text',
              ordemExibicao: Number(value.ordem_exibicao || 0),
              obrigatorio: Boolean(value.obrigatorio),
              ativo: value.ativo !== false,
              descricaoAjuda: value.descricao_ajuda || '',
              opcoes: Array.isArray(value.opcoes) ? value.opcoes : [],
            }
          : emptyForm();
        this.erros = {};
      },
    },
    'form.tipoCampo'(value) {
      if (!LIST_TYPES.includes(value)) this.form.opcoes = [];
    },
  },
  methods: {
    validar() {
      this.erros = {};
      if (!this.form.nomeExibicao.trim()) this.erros.nomeExibicao = 'Informe o nome de exibição.';
      if (!this.form.chaveTecnica.trim()) this.erros.chaveTecnica = 'Informe a chave técnica.';
      if (this.usaOpcoes && !this.form.opcoes.filter((opcao) => opcao.label && opcao.valor).length) {
        this.erros.opcoes = 'Cadastre ao menos uma opção válida.';
      }
      return Object.keys(this.erros).length === 0;
    },
    async salvar() {
      if (!this.validar()) return;
      this.salvando = true;
      try {
        await this.$emit('salvar', {
          nomeExibicao: this.form.nomeExibicao,
          chaveTecnica: this.form.chaveTecnica,
          tipoCampo: this.form.tipoCampo,
          ordemExibicao: this.form.ordemExibicao,
          obrigatorio: this.form.obrigatorio,
          ativo: this.form.ativo,
          descricaoAjuda: this.form.descricaoAjuda,
          opcoes: this.form.opcoes,
        });
      } finally {
        this.salvando = false;
      }
    },
    fechar() {
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}

.modal-backdrop {
  z-index: 1040;
}

.crm-modal-wide {
  max-width: min(1200px, calc(100vw - 1rem));
}
</style>
